import Dashboard from '@pages/Dashboard';
export const DashboardRoutes = [
    // { path: '/dashboard', name: 'dashboard', component: Dashboard  },
];
